import { withStyles, withTheme } from '@material-ui/core';
import BannerIcon from './BannerIcon';
import { compose } from 'recompose';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '40%',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center'
  },
  label: {
    fontSize: 24,
    fontWeight: 400,
    marginTop: 8,
    textAlign: 'center',
    color: theme.dispatchPanelLabelValueColor
  }
});
const Banner = ({ classes, theme }) => {
  return (
    <div className={classes.container}>
      <div>
        <BannerIcon color={theme.palette.primary.main} />
      </div>
      <div className={classes.label}>
        You're all done with shipment selection. <br></br>Now let's optimize your routes!
      </div>
    </div>
  );
};

export default compose(withTheme(), withStyles(styles))(Banner);
